/**
 * Modify 처리 핸들러 클래스
 * Modify 시작/종료 시 데이터 처리 및 서버 전송을 담당합니다.
 */
export class ModifyHandler {
  constructor(transformationTracker, transformationApi) {
    this.transformationTracker = transformationTracker;
    this.transformationApi = transformationApi;
  }

  /**
   * Modify 시작 시 초기 상태 저장
   * @param {Object} event - Modify 시작 이벤트
   */
  handleModifyStart(event) {
    const features = event.features.getArray();

    // 변형 추적 시작
    this.transformationTracker.saveInitialState('modify', features);

    console.log('[ModifyHandler] Modify 시작 - 초기 상태 저장 완료', {
      featureCount: features.length
    });
  }

  /**
   * Modify 완료 시 데이터 처리 및 서버 전송
   * @param {Object} event - Modify 완료 이벤트
   * @returns {Promise<Object>} 처리 결과
   */
  async handleModifyEnd(event) {
    const features = event.features.getArray();

    try {
      // 서버 전송용 데이터 생성
      const serverData = this.transformationTracker.createServerTransformationData(features);

      if (!serverData) {
        console.warn('[ModifyHandler] 서버 전송 데이터 생성 실패');
        return { success: false, error: '데이터 생성 실패' };
      }

      // 서버로 전송
      const response = await this.transformationApi.updateImageCoordinates(serverData);

      console.log('[ModifyHandler] Modify 완료 처리', {
        success: response.success,
        featureCount: features.length
      });

      return response;

    } catch (error) {
      console.error('[ModifyHandler] Modify 처리 중 오류', error);
      return { success: false, error: error.message };
    }
  }
}
